<template>
<div class="error-component error-cant-reach-server card border-warning text-center">
  <div class="card-header bg-warning">
    เงินของ{{sideText}}ไม่เพียงพอ
  </div>
  <div class="card-body">   
    <p class="card-text">{{sideText}}ต้องเติมเงินเข้าระบบให้เพียงพอเพื่อดำเนินการต่อ</p>
  </div>
</div>
</template>

<script>
export default {
  data: () => ({
    sideText: 'คุณ',
  }),
  created() {
    if (this.side === 'b') {
      this.sideText = 'ผู้ขอกู้/ผู้ขอซื้อ';
    }
    if (this.side === 'l') {
      this.sideText = 'ผู้ให้กู้/ผู้ขาย';
    }
  },
  props: {
    side: {
      type: String,
      default: ''
    },
  },
}
</script>

<style lang="scss">
</style>
